export enum TaskStatus {
  ToDo = 'todo',
  CantDo = 'cant_do',
  InProgress = 'in_progress',
  Completed = 'completed',
}

export const TaskStatusNames = Object.freeze({
  [TaskStatus.ToDo]: 'To Do',
  [TaskStatus.CantDo]: 'On hold',
  [TaskStatus.InProgress]: 'In Progress',
  [TaskStatus.Completed]: 'Completed',
});

export enum TaskState {
  Created = 'created',
  Deleted = 'deleted',
}

export enum ScheduleStatus {
  Overdue = 'overdue',
  Upcoming = 'upcoming',
  Completed = 'completed',
  WontDo = 'wont_do',
}
